"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dclController = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.dclController = {
    [schemas_1.ChainId.ETHEREUM_GOERLI]: {
        version: '1',
        abi: abis_1.abis.DCLController,
        address: '0x6ff05b6271bbed8f16a46e6073d27ad94224e0ac',
        name: 'DCLController',
        chainId: schemas_1.ChainId.ETHEREUM_GOERLI
    },
    [schemas_1.ChainId.ETHEREUM_MAINNET]: {
        version: '1',
        abi: abis_1.abis.DCLController,
        address: '0x6843291bd86857d97f0d269e698939fb10d60772',
        name: 'DCLController',
        chainId: schemas_1.ChainId.ETHEREUM_MAINNET
    }
};
//# sourceMappingURL=dclController.js.map